<template>
  <v-card>
    <v-toolbar dark color="#0c88c2">
      <v-btn icon dark @click="toggleDialog">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Invoice Details (ID: {{invoiceInfo.id}})</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text float-left @click="newRegionDialog = true;" v-if="edit">Add a new Section
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-container v-for="(section, indexSection) in invoiceInfo.sections" :key="indexSection">
      <v-row justify="space-between">
        <v-col :class="{'text-center': $vuetify.breakpoint.smAndDown}">
          <h2 class="raleway-bold">{{section.header}}</h2>
        </v-col>
        <v-col class="d-flex justify-space-around">
          <v-btn fab dark color="blue" @click="openNewLineDialog(section, indexSection)" v-if="edit">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn v-if="edit" text color="red" @click="toggleDeleteSectionDialog(section, indexSection)">
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn text v-if="edit" color="indigo" @click="surchargeDialog=true; editedSection=indexSection">
            Add a fuel surcharge
          </v-btn>
        </v-col>
      </v-row>

      <template v-for="(info, index) in section.rows">
        <v-list three-line subheader>
          <v-list-item>
            <v-row align="center" :class="{'no-gutters': $vuetify.breakpoint.smAndDown}">
              <v-col cols="12" md="3">
                <v-list-item-content v-if="!(editedSection === indexSection && editedIndex === index)" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-divider></v-divider>
                  <v-list-item-title>Date: {{info.date}}</v-list-item-title>
                  <v-list-item-subtitle class="py-2">
                      Description: {{info.description}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Unit of Measure: {{info.uom}}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content v-else :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title>
                    Date: <input v-model="editedRow.date">
                  </v-list-item-title>
                  <v-list-item-subtitle class="py-2">
                    Description: <input v-model="editedRow.description">
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                        Unit of Measure:
                    <v-select
                      :items="uoms"
                      v-model="editedRow.uom"
                      label="Select UOM"
                    ></v-select>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item-content v-if="!(editedSection === indexSection && editedIndex === index)" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title>
                    Quantity: {{info.quantity}}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title class="text--primary">
                    Quantity: <input v-model="editedRow.quantity">
                  </v-list-item-title>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item-content v-if="!(editedSection === indexSection && editedIndex === index)" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title>Unit Price: {{info.unit_price}}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title>
                    Unit Price: <input v-model="editedRow.unit_price">
                  </v-list-item-title>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item-content v-if="!(editedSection === indexSection && editedIndex === index)" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title class="font-weight-bold">Amount: {{info.amount}}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title class="font-weight-bold">
                    Amount: {{amount}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3" class="text-center">
                <v-list-item-action>
                  <v-row align="center">
                    <v-col cols="12" v-if="edit">
                      <v-speed-dial
                        small
                        direction="right"
                        transition="slide-y-reverse-transition"
                      >
                        <template v-slot:activator>
                          <v-btn
                            fab
                            small
                            dark
                            :color="(editedSection === indexSection && editedIndex === index) ? 'green' : '#00a7d3'"
                            @click="!(editedSection === indexSection && editedIndex === index) ? editLine(info, indexSection) : save()"
                          >
                            <v-icon v-if="!(editedSection === indexSection && editedIndex === index)">edit</v-icon>
                            <v-icon v-else>check</v-icon>
                          </v-btn>
                        </template>
                        <v-btn
                          @click="close()"
                          color="red"
                          fab
                          small
                          dark
                        >
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-speed-dial>
                    </v-col>
                    <v-col cols="12" class="text-center" v-if="edit">
                      <v-btn small text dark>
                        <v-icon color="red" @click="toggleDeleteDialog(index, indexSection)">delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item-action>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
      </template>
    </v-container>

    <v-dialog
      v-model="alertDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          ALERT
        </v-card-title>
        <v-card-text>
          {{message}}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn @click="alertDialog=false" text color="blue darken-1">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog" v-if="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          ALERT
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this line
          {{invoiceInfo.sections[lineToBeDeleted[1]].rows[lineToBeDeleted[0]].id}} ? <br>
          This action cannot be reversed.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="red" @click="deleteDialog=false">No</v-btn>
          <v-btn text color="blue darken-1" @click="deleteLine">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteSectionDialog" v-if="deleteSectionDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          ALERT
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete the section
          {{sectionToBeDeleted.header}} and all the invoices of the
          section ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="red" @click="deleteSectionDialog=false">No</v-btn>
          <v-btn text color="blue darken-1" @click="deleteSection">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="newLineDialog" width="800px">
      <v-card>
        <v-card-title>
          <h2>Line Information</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="newLineDialog=false;">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-row justify="space-around" align="center" class="py-4">
            <v-col cols="5">
              <h3>Invoice Number</h3>
            </v-col>
            <v-col cols="6">
              <h3>{{invoiceInfo.id}}</h3>
            </v-col>
            <v-col cols="5">
              <h3>Description</h3>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="editedRow.description"></v-text-field>
            </v-col>
            <v-col cols="5">
              <h3>UOM</h3>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                clearable
                :items="uoms"
                v-model="editedRow.uom"
                label="Pick a uom"
                :rules="uomsrules"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="5">
              <h3>Quantity</h3>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedRow.quantity"
                type="number"
                onkeydown="javascript: return event.keyCode == 69 ? false : true"
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <h3>Unit Price</h3>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedRow.unit_price"
                type="number"
                onkeydown="javascript: return event.keyCode == 69 ? false : true"
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <h3>Date</h3>
            </v-col>
            <v-col cols="6">
              <v-menu
                ref="menu1"
                v-model="menu1"
                close-on-content-click
                :nudge-bottom="100"
                transition="scale-transition"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    prepend-icon="event"
                    v-model="editedRow.date"
                    readonly></v-text-field>
                </template>
                <v-date-picker v-model="editedRow.date" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="5">
              <h3>Region</h3>
            </v-col>
            <v-col cols="6">
              <h3>{{regions[editedRow.region - 1].name}}</h3>
            </v-col>
            <v-col cols="5">
              <h3>Amount</h3>
            </v-col>
            <v-col cols="6">
              <h3>{{amount}}</h3>
              <!--<v-text-field v-model="editedRow.amount" class="headline"></v-text-field>-->
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-btn text @click="close" color="blue-grey lighten-2">Close</v-btn>
            <v-btn text @click="addNewLine" color="blue darken-1">Save</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="newRegionDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <h3>Select the region to add</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="newRegionDialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="newSection"
                :items="emptyRegions"
                label="Region"
                item-text="name"
                return-object
                @input="createNewSection"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="surchargeDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          Add a Fuel Surcharge
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                prefix="%"
                :value="12"
                type="number"
                v-model="fuelSurcharge"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="surchargeDialog=false">Cancel</v-btn>
          <v-btn text color="blue darken-1" @click="addFuelSurcharge">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
    import axios from 'axios'

    // @vuese
    // Invoices full screen displayer.
    // Allows you to manage every line of the invoices (add, delete or edit...).
    // @group Invoices
    export default {
        name: "InvoiceDisplayer",
        props: {
            toggleDialog: Function,
            edit: Boolean,
            invoiceInfo: Object,
            regions: Array,
        },
        data() {
            return {
                menu1: false,
                fab: false,
                alertDialog: false,
                surchargeDialog: false,
                message: '',
                keyCard: 0,
                closeSwitch: false,
                deleteDialog: false,
                deleteSectionDialog: false,
                lineToBeDeleted: [],
                sectionToBeDeleted: null,
                newLineDialog: false,
                maskInvoiceNum: '####################',
                maskQuantity: '####',
                maskUnitPrice: '##.##',
                maskAmount: '######.##',
                editedIndex: -1,
                editedSection: -1,
                editedRow: {
                    id: null,
                    inv_number: null,
                    description: null,
                    uom: null,
                    quantity: null,
                    unit_price: null,
                    date: null,
                    region: 1,
                    zone: null,
                    amount: null,
                },
                defaultRow: {
                    id: null,
                    inv_number: null,
                    description: null,
                    uom: null,
                    quantity: null,
                    unit_price: null,
                    date: null,
                    region: 1,
                    zone: null,
                    amount: null,
                },
                newLineSectionIndex: null,
                newRegionDialog: false,
                newSection: null,
                fuelSurcharge: 12.5,
                uoms: [],
                uomsrules:[
                  v => v !== null || 'Choose a valid UOM'
                ]
            }
        },
        methods: {
            // @vuese
            // Adds a fuel surcharge being fuelSurcharge(%) * total (for a section) and post it as a new line
            addFuelSurcharge() {
                let total = 0;
                for (var i = 0; i < this.invoiceInfo.sections[this.editedSection].rows.length; i++) {
                    total += this.invoiceInfo.sections[this.editedSection].rows[i].amount
                }
                let total_fuel = total * this.fuelSurcharge / 100;

                this.editedRow.quantity = 1;
                this.editedRow.date = this.invoiceInfo.date;
                this.editedRow.description = "Fuel Surcharge " + this.fuelSurcharge + '%';
                this.editedRow.uom = "Surcharge";
                this.editedRow.inv_number = parseFloat(this.invoiceInfo.id);
                this.editedRow.unit_price = total_fuel;
                this.editedRow.amount = total_fuel;

                axios.post(process.env.API_URL + '/invoices/' + this.invoiceInfo.id + '/lines', this.editedRow)
                    .then((response) => {
                        this.invoiceInfo.sections[this.editedSection].rows.unshift(response.data);
                        this.$store.commit('displaySnackbar', 'Fuel surcharge added');
                        this.surchargeDialog = false;
                        this.editedSection = -1;
                        this.fuelSurcharge = 12.5;
                        this.editedRow = this.defaultRow;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar','ERROR ' + response.response.data.error);
                        this.surchargeDialog = false;
                        this.editedSection = -1;
                        this.fuelSurcharge = 12.5;
                        this.editedRow = this.defaultRow;
                    });
            },
            // @vuese
            // Adds a new invoice line and POST it on /invoices/{invoice_id}/lines
            addNewLine() {
                this.editedRow.amount = this.amount;
                if(this.editedRow.uom == null){
                  this.$store.commit('displaySnackbar','ERROR Please pick UOM');
                  return;
                }
                axios.post(process.env.API_URL + '/invoices/' + this.invoiceInfo.id + '/lines', this.editedRow)
                    .then((response) => {
                        this.invoiceInfo.sections[this.newLineSectionIndex].rows.unshift(response.data);
                        this.$store.commit('displaySnackbar','New line created');
                    })
                    .catch((error) => {
                        this.$store.commit('displaySnackbar','ERROR ' +  error.response.data.error);
                    })
               this.newLineDialog = false;
                // this.$vuetify.goTo(9999, {duration: 1000, offset: 1000});
            },
            // @vuese
            // Toggles editable fields for this row
            // @arg Takes invoice object user wants to edit and its section index as arguments
            editLine(item, sectionIndex) {
                // this.editedIndex = this.lineArray.indexOf(item);
                this.editedIndex = this.invoiceInfo.sections[sectionIndex].rows.indexOf(item);
                this.editedSection = sectionIndex;
                this.editedRow = Object.assign({}, item);
                this.editArray[this.editedIndex] = true;
            },
            // @vuese
            // Saves changes on editedRow and resets every relevant variable to default
            save() {
                if (this.editedIndex > -1) {
                    this.editedRow.quantity = parseFloat(this.editedRow.quantity);
                    this.editedRow.unit_price = parseFloat(this.editedRow.unit_price);
                    this.editedRow.amount = this.amount;
                    axios.put(process.env.API_URL + '/invoices/lines/' + this.editedRow.id, this.editedRow)
                        .then((response) => {
                            Object.assign(this.invoiceInfo.sections[this.editedSection].rows[this.editedIndex], response.data);
                            this.$store.commit('displaySnackbar', 'Invoice line edited.');
                            this.close();
                        })
                        .catch((error) => {
                            this.close();
                            this.$store.commit('displaySnackbar', 'ERROR' + error);
                        })
                } else {
                    this.close();
                }
            },
            // @vuese
            // Closes edit/newLine dialog and resets every relevant variable to default
            close() {
                this.editArray[this.editedIndex] = false;
                this.editedRow = Object.assign({}, this.defaultRow);
                this.editedIndex = -1;
                this.editedSection = -1;
                this.newLineSectionIndex = null;
                this.newLineDialog = false;
            },
            // @vuese
            // Resets relevant variables to default values and opens new line dialog
            // @arg Takes section object and indexSection as arguments
            openNewLineDialog(section, indexSection) {
                // Reset to default values

                this.editedRow = this.defaultRow;
                this.newLineSectionIndex = indexSection;

                this.editedRow.region = this.regions.filter((region) => {
                    return region.name === section.header
                })[0].id;
                this.editedRow.id = this.invoiceInfo.id;
                this.editedRow.date = this.invoiceInfo.date;
                this.newLineDialog = true;
            },
            // @vuese
            // Stores the invoice line as lineToBeDeleted variable with its indexSection and toggles delete dialog
            // @arg Takes the index of the invoice the user wants to delete and its indexSection as arguments
            toggleDeleteDialog(index, indexSection) {
                this.lineToBeDeleted = [index, indexSection];
                this.deleteDialog = true;
            },
            // @vuese
            // Stores the invoice section as sectionToBeDeleted variable with its indexSection and toggles delete dialog
            // @arg Takes the section object the user wants to delete and its indexSection as arguments
            toggleDeleteSectionDialog(section, indexSection) {
                this.sectionToBeDeleted = [section, indexSection];
                this.deleteSectionDialog = true;
            },
            // @vuese
            // Deletes lineToBeDeleted object and resets every relevant variable to default
            deleteLine() {
                this.deleteDialog = false;
                // this.message = 'You deleted the line ' + 'successfully !';
                // this.alertDialog = true;

                axios.delete(process.env.API_URL + '/invoices/lines/'
                    + this.invoiceInfo.sections[this.lineToBeDeleted[1]].rows[this.lineToBeDeleted[0]].id)
                    .then((response) => {
                        this.invoiceInfo.sections[this.lineToBeDeleted[1]].rows.splice(this.lineToBeDeleted[0], 1);
                        this.$store.commit('displaySnackbar', 'Invoice line deleted');
                        this.lineToBeDeleted = [];
                    })
                    .catch((error) => {
                        this.$store.commit('displaySnackbar', 'ERROR' + error);
                    })

            },
            // @vuese
            // Deletes sectionToBeDeleted object and resets every relevant variable to default
            deleteSection() {
                this.deleteSectionDialog = false;
                // this.message = 'You deleted the section ' + 'successfully !';
                // this.alertDialog = true;

                this.$store.commit('displaySnackbar', 'You deleted the section "' + this.invoiceInfo.sections[this.sectionToBeDeleted[1]].header
                    + '" successfully.');
                this.invoiceInfo.sections.splice(this.sectionToBeDeleted[1], 1);

                this.lineToBeDeleted = [];

            },

            // @vuese
            // Creates a new section (front-end only)
            createNewSection() {
                this.newRegionDialog = false;
                this.invoiceInfo.sections.push(
                    {
                        header: this.newSection.name,
                        rows: [],
                        total: null,
                    }
                );
                this.newLineDialog = false;
                this.$store.commit('displaySnackbar', 'New section created: ' + this.newSection.name);
            },
            isObject(item){
                return typeof item == "object"
            }
        },
        computed: {
            // @vuese
            // Returns the title for the editDialog : 'New Item' or 'Edit Item'
            dialogTitle() {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },
            // @vuese
            // Returns an array filled with true value for indexes of invoice lines that are being edited
            editArray() {
                let editArray = [];
                for (var j = 0; j < this.invoiceInfo.sections.length; j++) {
                    for (var i = 0; i < this.invoiceInfo.sections[j].rows.length; i++) {
                        editArray.push(false);
                    }
                }
                return editArray
            },
            // @vuese
            // Returns the amount of the editedRow being quantity * unit_price
            amount() {
                return this.editedRow.quantity * this.editedRow.unit_price
            },
            // @vuese
            // Returns a list of all the regions that don't contain any invoice line
            emptyRegions() {
                return this.regions.filter((elt) => {
                    return !this.invoiceInfo.sections.map((section) => {
                        return section.header
                    }).includes(elt.name)
                })
            }

        },
        mounted() {
            axios.get(process.env.API_URL + '/invoices/uoms')
                .then((response) => {
                    this.uoms = response.data.map(x => x.name);
                })
                .catch((response) => {
                    this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                })
        }
    }
</script>

<style scoped>
  input {
    width: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/components/util/Invoices/InvoiceDisplayer.vue